import { FC } from "react";
import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";
import PassengerTabs from "../PassengerTabs/PassengerTabs";
import PassengerFields, { PassengerHeaderFields } from "../PassengerFields/PassengerFields";

interface PassengerFormListProps {
  form: any;
  activePassengerState: any;
  onPrev: () => void;
  onNext: () => void;
}

const PassengerFormList: FC<PassengerFormListProps> = ({ form, activePassengerState, onPrev, onNext }) => {
  const { t } = useTranslation();
  const [activePassenger] = activePassengerState;
  return (
    <Form.List name={["passengers"]}>
      {(fields) => {
        const passengers = form.getFieldValue(["passengers"]) || [];
        const isFirst = activePassenger === 0;
        const isLast = activePassenger === passengers.length - 1;
        const shouldRenderTabs = passengers.length > 1;
        return (
          <div className="flex flex-col gap-3">
            {shouldRenderTabs && (
              <div>
                <PassengerTabs fields={fields} passengers={passengers} activePassengerState={activePassengerState} form={form} />
              </div>
            )}
            <div className="bg-background-default flex flex-col gap-4 rounded-sm p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1 text-lg font-semibold">
                  <div>{t("Flights.details.passengers.passengerNumber", { number: activePassenger + 1 })}</div>
                  <div>({t(`Flights.details.passengerType.${passengers?.[activePassenger]?.type?.toLowerCase()}`)})</div>
                </div>
                {fields.map((field, index) => (
                  <div key={field.key} style={{ display: index === activePassenger ? "contents" : "none" }}>
                    <PassengerHeaderFields field={field} passengerType={passengers[index]?.type} form={form} />
                  </div>
                ))}
              </div>
              <div>
                {fields.map((field, index) => (
                  <div key={field.key} style={{ display: index === activePassenger ? "block" : "none" }}>
                    <PassengerFields field={field} passengerType={passengers[index]?.type} form={form} />
                  </div>
                ))}
              </div>
              <div className="flex items-center">
                {!isFirst && (
                  <Button type="default" className="w-30 p-5! bg-background-default! border-border-default!" onClick={onPrev}>
                    {t("Flights.details.passengers.previous")}
                  </Button>
                )}
                {!isLast && (
                  <Button type="primary" className="w-30 p-5! ms-auto" htmlType="button" onClickCapture={onNext}>
                    {t("Flights.details.passengers.next")}
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      }}
    </Form.List>
  );
};

export default PassengerFormList;
